import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconChecklist } from "@tabler/icons-react";
import { DatosServiciosGestionDef } from "./DatosServiciosGestionDef";

export const DatosServiciosIcon = IconChecklist;
export const DatosServiciosHelpText = '* Datos Servicios Gestión';

export class DatosServiciosGestion extends Entity<DatosServiciosGestionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosGestionDef(), parentKeys);
        this.Form = import('./DatosServiciosGestionForm').then((module) => module.DatosServiciosGestionForm);
        this.Title = "Gestionar Reporte";
        this.HelpText = DatosServiciosHelpText;
        this.Icon = DatosServiciosIcon;
    }
}